export default  {
    state: {
        brands: [],
        categories: [],
        product_units: [],
        items: [],
        stores: [],
        suppliers: [],
        payments: [],
        shelves: [],
        states: [],
        facilities: []
    },

    getters: {
        getSelectBrands: state => state.brands,

        getSelectCategories: state => state.categories,

        getSelectProductUnits: state => state.product_units,

        getSelectItems: state => state.items,

        getSelectStores: state => state.stores,

        getSelectSuppliers: state => state.suppliers,

        getSelectPayments: state => state.payments,

        getSelectShelves: state => state.shelves,

        getSelectInventoryStates: state => state.states,

        getSelectInventoryFacilities: state => state.facilities,
    },

    mutations: {
        setSelectBrands: (state, payload) => {
            state.brands = payload;
        },

        setSelectInventoryStates: (state, payload) => {
            state.states = payload;
        },

        setSelectInventoryFacilities: (state, payload) => {
            state.facilities = payload;
        },
    },

    actions: {
        fetchSelectBrands: ({commit}) => {
            const brands = {
                "data": [
                    {
                        "brand_id": 1,
                        "label": "Mobile1",
                        "data": {
                            "type": "Product Brands",
                            "attributes": {
                                "code": "PRU000001",
                                "name": "Mobile1",
                                "description": "test-q",
                                "image": "image3.jpg",
                                "status": "Active"
                            }
                        },
                        "links": {"self": "brands\/1"}
                    },
                    {
                        "brand_id": 2,
                        "label": "Mobile2",
                        "data": {
                            "type": "Product Brands",
                            "attributes": {
                                "code": "PRU000002",
                                "name": "Mobile2",
                                "description": "test-a",
                                "image": "image1.jpg",
                                "status": "Inactive"
                            }
                        },
                        "links": {"self": "brands\/2"}
                    },
                    {
                        "brand_id": 3,
                        "label": "Mobile3",
                        "data": {
                            "type": "Product Brands",
                            "attributes": {
                                "code": "PRU000003",
                                "name": "Mobile3",
                                "description": "test-z",
                                "image": "image2.jpg",
                                "status": "Active"
                            }
                        },
                        "links": {"self": "brands\/3"}
                    }
                ],
                "links": {
                    "self": "\/brands",
                    "first": "http:\/\/pilot.test\/api\/inventory\/products\/brands?page=1",
                    "last": "http:\/\/pilot.test\/api\/inventory\/products\/brands?page=3",
                    "prev": null,
                    "next": "http:\/\/pilot.test\/api\/inventory\/products\/brands?page=2"
                },
                "meta": {
                    "current_page": 1,
                    "from": 1,
                    "last_page": 3,
                    "path": "http:\/\/pilot.test\/api\/inventory\/products\/brands",
                    "per_page": "10",
                    "to": 10,
                    "total": 21
                }
            };

            return new Promise((resolve, reject) => {
                commit('setSelectBrands', brands.data);

                resolve(brands);
            });
        },

        fetchSelectInventoryStates: ({commit}) => {
            return new Promise((resolve, reject) => {
                axios.get('/api/inventory/select/states')
                    .then(response => {
                        commit('setSelectInventoryStates', response.data.data);

                        resolve(response.data.data);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },

        fetchSelectInventoryFacilities: ({commit}) => {
            return new Promise((resolve, reject) => {
                axios.get('/api/inventory/select/facilities')
                    .then(response => {
                        commit('setSelectInventoryFacilities', response.data.data);

                        resolve(response.data.data);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },
    }
}
